import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/somewhat-satisfied-filled.vue
var o = {
	name: "DtIconSomewhatSatisfiedFilled",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--somewhat-satisfied-filled"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Somewhat Satisfied Filled",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M11.375 5.938a5.437 5.437 0 1 0-10.875 0 5.437 5.437 0 0 0 10.875 0Zm-3.5-1.5A.438.438 0 0 0 7.437 4h-.005a.437.437 0 1 0 0 .875h.005a.437.437 0 0 0 .438-.438Zm-3 0A.438.438 0 0 0 4.437 4h-.005a.437.437 0 1 0 0 .875h.005a.437.437 0 0 0 .438-.438Zm3.559 2.734a.438.438 0 0 0-.613-.082l-.083.063a1.688 1.688 0 0 1-1.025.347H5.206c-.394 0-.776-.138-1.08-.39l-.01-.009a.438.438 0 1 0-.56.673l.011.009c.46.382 1.04.592 1.639.592h1.507c.563 0 1.11-.185 1.557-.527l.082-.063a.437.437 0 0 0 .082-.613Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=somewhat-satisfied-filled.js.map